import api from 'utils/api';
import { getAPIBase } from 'utils/api/apiBase';

/**
 * Frees this device's slot under the single-device limit. Fire-and-forget: callers ignore the outcome,
 * and `204` just means the backend has the feature off.
 */
export const releaseDevice = async ({ uid, deviceId }) =>
  api.post(`${getAPIBase()}/devices/release/`, { uid, device: { id: deviceId } });
